<section class="complete-section">
  <ng-container [ngSwitch]="screen">
    <ng-container *ngSwitchCase="'SELECT_FIELDS'">
      <!-- STICKY HEADER -->
      <div class="sticky-sidebar-header">
        <div class="header-title-container">
          <h3 class="header-text">Edit Custom fields</h3>
        </div>
        <div class="done-btn-wrapper" (click)="dismiss()">
          <span class="done-btn-text">Done</span>
        </div>
      </div>

      <!-- STICKY SEARCH BAR -->
      <div class="sticky-search-wrapper">
        <div class="search-container">
          <div class="search-icon">
            <img src="https://d2z9497xp8xb12.cloudfront.net/prod-images/864641c1762337407952Icon.svg" alt="search">
          </div>
          <input class="search-input" [(ngModel)]="searchField" (ngModelChange)="searchListField()"
            placeholder="Search by field name">
        </div>
      </div>

      <!-- SCROLLABLE FIELDS LIST -->
      <div class="fields-scroll-content">
        <div *ngIf="dataSource.length > 0" class="fields-list">
          <div class="field-item-row" *ngFor="let element of dataSource">
            <div class="field-item-left">
              <label class="custom-checkbox-label">
                <input type="checkbox" [checked]="element.showInForm?.includes('ENQUIRY') || false"
                  (change)="updateItem($event, element)" />
                <span class="label-text">
                  {{ element?.fieldLabel | titlecase }}
                </span>
              </label>
            </div>
            <div class="field-item-right">
              <label class="custom-checkbox-label required-badge">
                <input type="checkbox" [checked]="element.required" (change)="upadteIsRequired($event, element)" />
                <span class="label-text required-label"> Is Required </span>
              </label>
            </div>
          </div>
        </div>

        <div *ngIf="dataSource.length === 0" class="no-fields-container">
          <p>No Fields Found.</p>
        </div>

        <div class="form-check-options" *ngFor="let field of customAddedFields; let i = index">
          <div class="form-check" [ngStyle]="{'background-color' : field.required ? 'rgb(238, 234, 234)' : ''}">
            <input class="form-check-input" type="checkbox" value="" [id]="i + '_custom'" [(ngModel)]="field.status"
              [disabled]="field.required" (ngModelChange)="changeTextField(field, 'CHECK')">
            <label class="form-check-label" [for]="i + '_custom'">
              <span>{{field.label}}</span>
            </label>
            <div class="ml-auto" style="display: flex; gap: 10px">
              <mat-icon (click)="editInput(field)">edit</mat-icon>
              <mat-icon (click)="deleteInput(field)">delete_outline</mat-icon>
            </div>
          </div>
        </div>
      </div>

      <!-- STICKY FOOTER -->
      <div class="sticky-sidebar-footer">
        <button class="add-custom-field-btn" (click)="screen = 'ADD_FIELDS'">
          <span class="plus-icon">+</span> Add custom field
        </button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'ADD_FIELDS'">
      <!-- STICKY HEADER -->
      <div class="sticky-sidebar-header">
        <div class="header-left-group" (click)="screen = 'SELECT_FIELDS'">
          <mat-icon class="back-icon cursor-pointer">arrow_back</mat-icon>
          <h3 class="header-text">Add a custom field</h3>
        </div>
        <div class="close-icon-btn" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </div>
      </div>

      <div class="add-fields-scroll-content">
        <div class="info-alert-card" *ngIf="data?.screen != 'CUSTOM_FORM'">
          <mat-icon class="info-icon">info</mat-icon>
          <span class="info-text">Fields added here are also added to contacts in your Enquiry</span>
        </div>

        <div class="available-fields-grid">
          <ng-container *ngFor="let field of availableFields">
            <div class="available-field-card cursor-pointer" (click)="addNewInput(field)">
              <div class="field-icon-badge">
                <span *ngIf="field.customIcon">{{ field.iconTxt }}</span>
                <mat-icon *ngIf="!field.customIcon">{{ field.icon }}</mat-icon>
              </div>
              <div class="field-card-info">
                <span class="field-title">{{ field.text | titlecase }}</span>
                <p class="field-desc">{{ field.description }}</p>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'EDIT_FIELD'">
      <div class="header">
        <div *ngIf="!data.edit" class="header-text">Create the {{ getInputType === 'desc' ? 'text area' : getInputType |
          lowercase }} field</div>
        <div *ngIf="data.edit" class="header-text">Edit the {{ getInputType | lowercase }} field</div>
        <p class="close-btn mb-0" (click)="closeModal()"><mat-icon>close</mat-icon> </p>
      </div>


      <!-- <hr class="line"> -->
      <div class="field-edit-container">
        <!-- <hr class="line"> -->
        <label class="fieldgroup mb-1">Field Group</label>
        <mat-form-field class="addGroupField" appearance="outline">
          <mat-select placeholder="Select Field Group" multiple [(ngModel)]="selectedFieldGroups" required>
            <mat-option *ngFor="let group of fieldGroups" [value]="group">
              {{ group.fieldGroupName }}
            </mat-option>
            <mat-option (click)="opencreategroup()">+ Create Field Group</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- <div class="mtb-15" *ngIf="data?.screen != 'CUSTOM_FORM'">
          <label class="fieldgroup">Field Type</label>
          <mat-form-field class="addGroupField" appearance="outline">
            <mat-select placeholder="Select Field Type" [(ngModel)]="payload.type">
              <mat-option *ngFor="let type of fieldTypeList" [value]="type.name">
                {{ type.displayText }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->


        <div class="custom-inputs" *ngIf="selectedInputType === 'text' || selectedInputType === 'desc' ">
          <div class="body">
            <div class="label">
              <label class="input-label mb-1">Field Label</label>
              <input class="input-text" placeholder="Name" type="text" [(ngModel)]="payload.fieldLabel" required />
              <div *ngIf="!payload.fieldLabel" class="error">Field Label is required</div>
            </div>

            <div class="hint">
              <label class="input-label mb-1">{{data?.screen === 'CUSTOM_FORM' ? 'Placeholder Text' : 'Field
                Hint'}}</label>
              <input class="input-text" placeholder="Enter hint for the field" type="text" [(ngModel)]="payload.hint" />
            </div>

            <div class="limits d-flex" *ngIf="data?.screen != 'CUSTOM_FORM'">
              <div class="limit">
                <label class="input-label">Min Limit</label>
                <input class="input-limit" type="text" [(ngModel)]="payload.minLimit" (input)="checkLimits()" />
              </div>

              <div class="limit">
                <label class="input-label">Max Limit</label>
                <input class="input-limit" type="text" [(ngModel)]="payload.maxLimit" (input)="checkLimits()" />
                <div class="text-danger"
                  *ngIf="payload.maxLimit < 50 && (this?.payload?.dataType === 'desc' || this.selectedInputType === 'desc')">
                  Max limit should not be less than 50
                </div>
              </div>
            </div>

            <div *ngIf="showWarning && data?.screen != 'CUSTOM_FORM'" class="warning">
              <p style="color: red;">*Min Limit should be less than Max Limit!</p>
            </div>



            <div class="validaiton" *ngIf="data?.screen != 'CUSTOM_FORM'">
              <div class="v-heading">
                <label class="input-label">Validation</label>
              </div>
              <mat-form-field class="multiselect" appearance="outline">
                <mat-select class="inputStyle" placeholder="Select validation" multiple
                  [(ngModel)]="selectedValidations" (selectionChange)="updateDataFieldConstraints()">
                  <mat-option *ngFor="let validation of validationList" [value]="validation">
                    {{ validation.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
        </div>

        <div class="custom-inputs" *ngIf="selectedInputType === 'number'">
          <div class="body">
            <div class="label">
              <label class="input-label">Field Label</label>
              <input class="input-text" placeholder="Name" type="text" [(ngModel)]="payload.fieldLabel" required />
              <div *ngIf="!payload.fieldLabel" class="error">Field Label is required</div>
            </div>

            <div class="hint">
              <label class="input-label">Field Hint</label>
              <input class="input-text" placeholder="Enter hint for the field" type="text" [(ngModel)]="payload.hint" />
            </div>

            <div class="limits d-flex" *ngIf="data?.screen != 'CUSTOM_FORM'">
              <div class="limit">
                <label class="input-label">Min Limit</label>
                <input class="input-limit" type="text" [(ngModel)]="payload.minLimit" />
              </div>

              <div class="limit">
                <label class="input-label">Max Limit</label>
                <input class="input-limit" type="text" [(ngModel)]="payload.maxLimit" />
              </div>
            </div>



            <div class="validaiton">
              <div class="v-heading">
                <label class="input-label">Validation</label>
              </div>
              <mat-form-field class="multiselect" appearance="outline">
                <mat-select class="inputStyle" placeholder="Select validation" multiple
                  [(ngModel)]="selectedValidations" (selectionChange)="updateDataFieldConstraints()">
                  <mat-option *ngFor="let validation of validationList" [value]="validation">
                    {{ validation.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
        </div>

        <div class="custom-inputs" *ngIf="selectedInputType === 'money'">
          <div class="body">
            <div class="label">
              <label class="input-label">Field Label</label>
              <input class="input-text" placeholder="Enter amount in ₹" type="text" [(ngModel)]="payload.fieldLabel"
                required />
              <div *ngIf="!payload.fieldLabel" class="error">Field Label is required</div>
            </div>

            <div class="hint">
              <label class="input-label">Field Hint</label>
              <input class="input-text" placeholder="Enter amount" type="text" [(ngModel)]="payload.hint" />
            </div>

            <div class="limits d-flex" *ngIf="data?.screen != 'CUSTOM_FORM'">
              <div class="limit">
                <label class="input-label">Min Limit</label>
                <input class="input-limit" type="text" placeholder="500₹" [(ngModel)]="payload.minLimit" />
              </div>

              <div class="limit">
                <label class="input-label">Max Limit</label>
                <input class="input-limit" type="text" placeholder="5000₹" [(ngModel)]="payload.maxLimit" />
              </div>
            </div>
          </div>
        </div>

        <div class="custom-inputs" *ngIf="selectedInputType === 'date'">
          <div class="body">
            <label class="input-label">Field Label</label>
            <input class="input-text" placeholder="Name" type="text" [(ngModel)]="payload.fieldLabel" />

            <div class="hint">
              <label class="input-label">Field Hint</label>
              <input class="input-text" placeholder="Enter hint for the field" type="text" [(ngModel)]="payload.hint" />
            </div>

          </div>
        </div>

        <div class="custom-inputs" *ngIf="selectedInputType === 'checkbox'">
          <div class="body">
            <div class="label">
              <label class="input-label">Field Label</label>
              <input class="input-text" placeholder="Name" type="text" [(ngModel)]="payload.fieldLabel" required />
              <div *ngIf="!payload.fieldLabel" class="error">Field Label is required</div>
            </div>

            <div class="hint">
              <label class="input-label">Field Hint</label>
              <input class="input-text" placeholder="Enter hint for the field" type="text" [(ngModel)]="payload.hint" />
            </div>

          </div>
        </div>

        <div class="custom-inputs" *ngIf="selectedInputType === 'dropdown'">
          <label class="input-label">Dropdown Name</label>
          <input class="input-text" type="text" [(ngModel)]="payload.fieldLabel" />

          <label class="mtb-15" *ngIf="data?.screen != 'CUSTOM_FORM'">
            <input type="checkbox" name="" id="" [(ngModel)]="payload.multipleSelection">
            multiple Selection
          </label>

          <div class="hint">
            <label class="input-label">Field Hint</label>
            <input class="input-text" placeholder="Enter hint for the field" type="text" [(ngModel)]="payload.hint" />
          </div>

        </div>

        <div class="custom-inputs" *ngIf="selectedInputType === 'radioButton'">
          <label class="input-label">Radio Button Name</label>
          <input class="input-text" type="text" [(ngModel)]="payload.fieldLabel" />

          <div class="hint">
            <label class="input-label">Field Hint</label>
            <input class="input-text" placeholder="Enter hint for the field" type="text" [(ngModel)]="payload.hint" />
          </div>

        </div>



        <div class="custom-inputs" *ngIf="selectedInputType === 'rating'">
          <div class="body">

            <label class="input-label">Field Label</label>
            <input class="input-text" placeholder="Name" type="text" [(ngModel)]="payload.fieldLabel" />
            <!-- <p> Hint: Enter your full name</p> -->

            <div class="hint">
              <label class="input-label">Field Hint</label>
              <input class="input-text" placeholder="Enter hint for the field" type="text" [(ngModel)]="payload.hint" />
            </div>

            <div class="limits d-flex" *ngIf="data?.screen != 'CUSTOM_FORM'">
              <div class="limit">
                <label class="input-label">Min Limit</label>
                <input class="input-limit" type="text" [(ngModel)]="payload.minLimit" />
              </div>

              <div class="limit">
                <label class="input-label">Max Limit</label>
                <input class="input-limit" type="text" [(ngModel)]="payload.maxLimit" />
              </div>
            </div>
          </div>
        </div>
        <ng-container
          *ngIf="selectedInputType == 'checkbox' || selectedInputType == 'dropdown' || selectedInputType == 'radioButton'">
          <div *ngIf="data?.screen != 'CUSTOM_FORM'">
            <div class="options-container">
              <span>Select Data Source</span>
            </div>
            <mat-radio-group [(ngModel)]="selectedSourceOption" (change)="onSelectionChange($event)">
              <mat-radio-button class="header-text" value="Masters">Masters</mat-radio-button>
              <mat-radio-button class="input-label" value="Custom Options">Custom Options</mat-radio-button>
            </mat-radio-group>
          </div>

          <div *ngIf="selectedSourceOption === 'Masters'">

            <mat-form-field class="addGroupField" appearance="outline">
              <mat-select placeholder="Choose Master" [(ngModel)]="selectedSourceItem" required>
                <mat-option *ngFor="let item of dataSourceTypes" [value]="item">
                  {{ item | titlecase}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container
          *ngIf="(selectedInputType === 'checkbox' || selectedInputType === 'dropdown' || selectedInputType === 'radioButton') && selectedSourceOption === 'Custom Options'">
          <div class="options-container">
            <span>Options</span>
            <span class="addMoreField-options cursor-pointer" (click)="addMoreOption()"
              [ngClass]="{'disabled-add': !canAddMoreOption}"> +
              Add option
            </span>
          </div>

          <div class="optionsList" cdkDropList (cdkDropListDropped)="drop($event)">
            <div class="custom-inputs" *ngFor="let option of fieldOptions; let idx = index">
              <div class="d-flex align-items-center">
                <input class="input-text" type="text" [(ngModel)]="fieldOptions[idx].value"
                  (keydown.enter)="addMoreOption()" (ngModelChange)="onOptionValueChange(idx, $event)" />
                <mat-icon class="text-danger" [ngClass]="{'disabled-delete': fieldOptions.length <= 2}"
                  style="margin-left: 15px; cursor: pointer;" (click)="removeOption(idx)">
                  delete_outline
                </mat-icon>
              </div>
              <div class="error" *ngIf="isValueConflict(idx)">Values cannot be same</div>
            </div>
          </div>
        </ng-container>

        <label class="input-label" *ngIf="data?.screen != 'CUSTOM_FORM'">Error Message</label>
        <input class="input-text" *ngIf="data?.screen != 'CUSTOM_FORM'" type="text"
          [(ngModel)]="payload.errorMessage" />

        <div class="checkbox-container">
          <div class="checkbox-row">
            <ng-container *ngIf="fieldCategory==='REGISTRATION'">
              <label>
                <input type="checkbox" color="accent" [(ngModel)]="payload.showInRegistration"
                  (change)="onCheckboxChange()" />
                Show in Registration Form
              </label>
            </ng-container>
            <ng-container *ngIf="fieldCategory==='ADMISSION'">
              <label>
                <input type="checkbox" color="accent" [(ngModel)]="payload.showInAdmission"
                  (change)="onCheckboxChange()" />
                Show in Admission Form
              </label>
            </ng-container>

            <ng-container *ngIf="(fieldCategory===null || fieldCategory==='ENQUIRY') && data.screen != 'CUSTOM_FORM'">
              <label>
                <input type="checkbox" color="accent" [(ngModel)]="payload.showInEnquiry"
                  (change)="onCheckboxChange()" />
                Show in Enquiry Form
              </label>
            </ng-container>
            <label>
              <input type="checkbox" color="accent" [(ngModel)]="payload.required" (change)="onCheckboxChange()" />
              Mark As Required
            </label>
          </div>

          <div class="checkbox-row">
            <label>
              <input type="checkbox" color="accent" [(ngModel)]="payload.filterable" (change)="onCheckboxChange()" />
              Mark As Filterable
            </label>
            <label>
              <input type="checkbox" [(ngModel)]="payload.searchable" (change)="onCheckboxChange()" />
              Mark As Searchable
            </label>
          </div>
        </div>

        <div class="checkbox-row">
          <label>
            <input type="checkbox" color="accent" [(ngModel)]="payload.hideInBulkUpload" (change)="onCheckboxChange()" />
            Hide in Field Mapping
          </label>
        </div>


      </div>
      <div class="action-btn-container">
        <div *ngIf="!data.edit" class="cancel-btn" (click)="cancelEdit()">Cancel</div>
        <div *ngIf="data.edit" class="cancel-btn" (click)="cancelfromlistedit()">Cancel</div>
        <div class="save-btn" (click)="saveEdit()" [class.disabled]="!isFormValid()">Save</div>
      </div>
    </ng-container>
  </ng-container>
</section>

<section class="loader_section" *ngIf="pageLoader">
  <div class="api_loader">
    <app-anime-loader></app-anime-loader>
  </div>
</section>